// Single source of truth for external endpoints.
//
// Values come from build-time env vars (see .env.example). react-scripts only
// exposes vars prefixed REACT_APP_, and they are inlined at build time — so
// never put a secret here. Anything in this file ships to the browser.

const trimTrailing = (s) => String(s).replace(/\/+$/, '');
const trimLeading = (s) => String(s).replace(/^\/+/, '');

// Origin serving collection media (CloudFront -> S3 bucket `kanoseiwebsite`).
export const ASSET_BASE = trimTrailing(
  process.env.REACT_APP_ASSET_BASE || 'https://dvdd44xqkx4sn.cloudfront.net/src'
);

// Backend API origin. Empty string means same-origin (e.g. `/api/contact`),
// which is what we get by routing /api/* through the same CloudFront
// distribution as the site. Set explicitly for local development.
export const API_BASE = trimTrailing(process.env.REACT_APP_API_BASE || '');

// Build a media URL. Joins without producing the `//` that the old
// `${window.src_path}/collection/...` pattern emitted.
export const assetUrl = (path) => `${ASSET_BASE}/${trimLeading(path)}`;

// Build an API URL. The `/api` prefix is added here, not by callers, because
// every backend route lives under it and CloudFront routes `/api/*` to the
// Lambda origin. So apiUrl('holdings') is `/api/holdings` in production and
// `http://localhost:3001/api/holdings` when API_BASE points at a local server.
export const apiUrl = (path) => `${API_BASE}/api/${trimLeading(path)}`;
